import './CategoryPage.scss'

import { graphql, PageProps } from 'gatsby'
import React, { FunctionComponent } from 'react'
import WidgetBuilder from 'Shared/components/builders/WidgetBuilder'
import EasySoftwareBreadcrumbs, {
  BreadcrumbItem,
} from 'Shared/components/EasySoftwareBreadcrumbs/EasySoftwareBreadcrumbs'
import PuxColumns, {
  PuxMainColumn,
  PuxSideColumn,
} from 'Shared/components/PuxColumns/PuxColumns'
import { localizedPathType } from 'Shared/components/PuxLanguageSelector/PuxLanguageSelector'
import PuxWysiwyg, {
  PuxWysiwygHtmlBodyType,
} from 'Shared/components/PuxWysiwyg/PuxWysiwyg'
import { WidgetPuxSectionType } from 'Shared/components/widgets/WidgetPuxSection'
import PuxMetaTags, { PuxMetaTagsType } from 'Shared/utils/PuxMetaTags'

import Layout from '../../components/core/Layout'

export interface CategoryType {
  contentType: string
  path: string
  contentItemId: string
  contentItemVersionId: string
  displayText: string
  categoryPageDescription: PuxWysiwygHtmlBodyType
  localization: {
    localizations: localizedPathType[]
  }
}

export interface CategoryPageType extends PageProps {
  data: {
    orchard: {
      easySoftwareCategoryPage: [CategoryType]
    }
  }
  pageContext: {
    pagePath: string
    widgets: {
      categoryWidgets: [WidgetPuxSectionType]
    }
    metaTags: PuxMetaTagsType
    breadcrumbs: [BreadcrumbItem]
    sideCardWidgets: any
  }
}

export const query = graphql`
  query($pagePath: String = "") {
    orchard {
      easySoftwareCategoryPage(first: 1, where: { path: $pagePath }) {
        contentType
        path
        contentItemId
        displayText
        localization {
          localizations {
            ... on Orchard_EasySoftwareCategoryPage {
              path
              published
              localization {
                culture
              }
            }
          }
        }
        categoryPageDescription {
          html
        }
      }
    }
  }
`

const rootClass = `category-page`

const CategoryPage: FunctionComponent<CategoryPageType> = (props) => {
  const data = props.data.orchard.easySoftwareCategoryPage[0]
  const widgets = props.pageContext.widgets
  const breadcrumbsData = props.pageContext.breadcrumbs

  return (
    <Layout localizedPath={data.localization?.localizations}>
      <EasySoftwareBreadcrumbs items={breadcrumbsData} />
      <PuxMetaTags {...props.pageContext.metaTags} />
      <div className='pux-container'>
        <div className={rootClass}>
          <PuxColumns>
            <PuxMainColumn>
              <h1 className={`${rootClass}-title`}>{data.displayText}</h1>
              <div className={`${rootClass}-perex perex`}>
                <PuxWysiwyg content={data.categoryPageDescription} />
              </div>
              <WidgetBuilder widgetBuilderData={widgets.categoryWidgets} />
            </PuxMainColumn>
            <PuxSideColumn>
              <div className='sidebar-sticky'>
                <WidgetBuilder
                  widgetBuilderData={props.pageContext.sideCardWidgets}
                />
              </div>
            </PuxSideColumn>
          </PuxColumns>
        </div>
      </div>
    </Layout>
  )
}

export default CategoryPage
